function modToggleNav(){
  var n=document.getElementById('modMobileNav');
  if(n){n.classList.toggle('open');}
}
function modCopyEmail(){
  var el=document.getElementById('modEmailText');
  if(!el)return;
  navigator.clipboard.writeText(el.innerText).then(function(){
    var b=document.querySelector('.copy-btn');
    if(b){var o=b.innerText;b.innerText='Copied';setTimeout(function(){b.innerText=o;},1500);}
  });
}
function modSetImage(t){
  var thumbs=document.querySelectorAll('.gallery-thumbs .thumb');
  thumbs.forEach(function(x){x.classList.remove('active');});
  t.classList.add('active');
  var main=document.getElementById('modGalleryMain');
  var img=t.getAttribute('data-image');
  if(main&&img){main.style.backgroundImage='url('+img+')';main.style.backgroundSize='cover';main.style.backgroundPosition='center';}
}
